// API configuration - set REACT_APP_API_URL in Railway environment variables
const API_BASE = process.env.REACT_APP_API_URL || 'https://api.kigitz.com';

export default API_BASE;
